export const GET_EMAIL_PREFERENCES = "GET_EMAIL_PREFERENCES";
export const GET_EMAIL_PREFERENCES_SUCCESS = "GET_EMAIL_PREFERENCES_SUCCESS";
export const GET_EMAIL_PREFERENCES_ERROR = "GET_EMAIL_PREFERENCES_ERROR";

export const UPDATE_EMAIL_PREFERENCES = "UPDATE_EMAIL_PREFERENCES";
export const UPDATE_EMAIL_PREFERENCES_SUCCESS =
  "UPDATE_EMAIL_PREFERENCES_SUCCESS";
export const UPDATE_EMAIL_PREFERENCES_ERROR = "UPDATE_EMAIL_PREFERENCES_ERROR";
